import React from "react";
import { ModalContext } from "./context";
import "bootstrap";
import $ from "jquery";

export const useModalBase = () => {
  const [modalContent, setModalContent] = React.useState(null);
  const [modalFullWidth, setModalFullWidth] = React.useState(null);

  const setModal = (content = false, fullWidth = false, show = true) => {
    console.log("Running setModal", content, fullWidth, show);
    if (content) {
      setModalContent(content);
      setModalFullWidth(fullWidth);
      if (show) {
        $("#global-modal").modal("show");
      }
    }
  };

  return { setModal, modalContent, modalFullWidth };
};

export const useModal = () => {
  const { setModal } = React.useContext(ModalContext);

  return {
    setModal: (content = false, fullWidth = false, show = true) =>
      setModal(content, fullWidth, show),
    showModal: () => $("#global-modal").modal("show"),
    hideModal: () => $("#global-modal").modal("hide"),
  };
};
